import { useMemo } from 'react';
import { requestForQuoteProductName } from '~/utils/requestForQuoteProductName';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useGetMyQuotes } from '~/api';
import { formatRelativeTime } from '~/utils';
import { DashboardListColumn } from './DashboardColumn';

export function QuotesToRespondColumn() {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetMyQuotes(0, 5, true);
  const quotes = useMemo(
    () =>
      [...(data?.myQuotes?.content ?? [])].sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      ),
    [data]
  );

  return (
    <DashboardListColumn
      title={t('dashboard.quotes_to_respond.title')}
      subtitle={t('dashboard.quotes_to_respond.subtitle')}
      items={quotes}
      isLoading={isLoading}
      isError={isError}
      emptyText={t('dashboard.quotes_to_respond.empty')}
      errorText={t('dashboard.quotes_to_respond.error')}
      getKey={(quote) => quote.id}
      sortBy={(a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      }
      renderRow={(quote) => (
        <>
          <div className="flex items-center justify-between gap-2">
            <button
              type="button"
              onClick={() => navigate(`/seller-quotes/view/${quote.id}`)}
              data-testid={`quote-to-respond-${quote.id}`}
              className="text-sm font-medium text-neut-prim hover:underline text-left"
            >
              {requestForQuoteProductName(quote.requestForQuote) ??
                t('dashboard.multiple_products')}
            </button>
            <p className="text-xs font-medium text-neut-sec shrink-0">
              {formatRelativeTime(quote.createdAt, t)}
            </p>
          </div>
          <div className="flex items-center justify-between gap-2">
            <p className="text-xs font-medium text-neut-sec">
              {quote.requestForQuote.buyingOrganization.name}
            </p>
            <p className="text-xs font-medium text-neut-sec">
              {t('dashboard.quotes_to_respond.item_count', {
                count: quote.items.length,
              })}
            </p>
          </div>
        </>
      )}
    />
  );
}
